// createCrudApi.js
const createCrudApi = (client, resource) => ({
    async getAll(params = {}) {
        const response = await client.get(`/${resource}`, { params });
        return response.data;
    },

    async getById(id) {
        const response = await client.get(`/${resource}/${id}`);
        return response.data;
    },

    async create(data) {
        const response = await client.post(`/${resource}`, data);
        return response.data;
    },

    async update(id, data) {
        const response = await client.put(`/${resource}/${id}`, data);
        return response.data;
    },

    async delete(id) {
        const response = await client.delete(`/${resource}/${id}`);
        return response.data;
    },
});

export default createCrudApi;

